<template>
  <div>
    <b-modal
      id="modal-input-pin"
      v-model="modalInputPin"
      size="lg"
      hide-footer
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      centered
    >
      <div class="box-pin mb-5">
        <div class="heading text-center">
          <h3 class="font-rubik-medium mb-5">
            PIN Keamanan
          </h3>
          <p class="font-rubik-regular" :class="isStatus ? '' : 'wrong-pin-text'">
            {{ isStatus ? 'Silakan masukkan PIN keamanan Anda' : 'Maaf, Anda memasukkan PIN yang salah' }}
          </p>
        </div>
        <div class="body-pin">
          <div class="flex justify-center mb-10 items-center md:mt-5 relative" style="flex-direction: row;">
            <client-only>
              <v-otp-input
                ref="otpInput"
                :input-classes="generatedClass"
                input-type="tel"
                separator=""
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChangePin"
              />
            </client-only>
            <div class="relative pt-4">
              <font-awesome-icon
                size="lg"
                :icon="isShowPin ? 'eye' : 'eye-slash'"
                class="cursor-pointer mt-1"
                @click="toggleShowPin"
              />
            </div>
          </div>
          <div class="box-forgot mt-3">
            <p v-if="!isReset" class="font-rubik-regular">
              Lupa PIN? <span @click="showModalReset(); $tracker({ action: 'cta_recover_pin', category: 'finance' })">Pulihkan <font-awesome-icon icon="chevron-circle-right" size="lg" /></span>
            </p>
            <p v-else class="font-rubik-regular text-center" style="font-weight: normal;">
              Anda telah 5 kali memasukkan PIN yang salah, silakan Reset PIN Keamanan Anda
            </p>
          </div>
        </div>
      </div>
      <div class="box-submit text-center">
        <nuxt-link v-if="!isReset" to="/console/dashboard">
          <button
            class="pl-6 text-white btn-cancel"
            @click="$tracker({ action: 'cta_cancel_input_pin', category: 'finance' })"
          >
            <font-awesome-icon icon="times-circle" size="lg" /> Batal
          </button>
        </nuxt-link>
        <button
          v-else
          class="pl-6 text-white box-reset"
          @click="showModalReset"
        >
          Reset PIN
        </button>
      </div>
    </b-modal>
    <input-password v-if="showInputPassword" />
  </div>
</template>
<script>
import inputPassword from '@/components/modal-dialog/InputPassword.vue'
export default {
  components: {
    inputPassword
  },
  data () {
    return {
      modalInputPin: true,
      isStatus: true,
      isReset: false,
      pin: '',
      isShowPin: false,
      showInputPassword: false,
      showInfoChangePeriod: false
    }
  },
  computed: {
    generatedClass () {
      const firstClass = this.isStatus ? 'otp-input' : 'otp-input wrong-pin'
      const secondClass = !this.isShowPin ? ' hide-password' : ''
      return firstClass + secondClass
    }
  },
  methods: {
    showModalReset () {
      this.showInputPassword = true
      this.modalInputPin = false
    },
    handleOnChangePin (value) {
      if (value.length === 6) {
        this.pin = value
        this.submitPIN()
        this.$tracker({
          action: 'txt_submit_pin',
          category: 'finance'
        })
      }
    },
    toggleShowPin () {
      this.isShowPin = !this.isShowPin
      this.$tracker({
        action: 'cta_show_pin',
        category: 'finance'
      })
    },
    async submitPIN () {
      const formData = new FormData()
      formData.append('PIN', this.pin)
      await this.$store.dispatch('user/inputPIN', formData)
        .then((res) => {
          this.$emit('onToken')
          this.modalInputPin = false
        })
        .catch((err) => {
          if (err.data.Message === 'PIN_INVALID') {
            this.isStatus = false
            this.$refs.otpInput.clearInput()
          } else if (err.data.Message === 'PIN_ATTEMPT_REACHED') {
            this.isReset = true
            this.isStatus = false
            this.$refs.otpInput.clearInput()
          }
        })
    }
  }
}
</script>

<style lang="scss">
  #modal-input-pin {
    background: #024668d1;
    .modal-body {
      padding: 3rem;
      .heading {
        h3 {
          color: #434343;
          font-size: 24px;
        }
        p {
          color: #434343;
          font-size: 18px;
          &.wrong-pin-text {
            color: #E70016;
          }
        }
      }
      .body-pin {
        .flex {
          display: flex;
          input {
            border: 0px;
            width: 80%;
            height: 80px;
            font-size: 60px;
            text-align: center;
            border-radius: 7px;
            background-color: #f3f2ef;
            &:focus-visible {
              outline: 0px;
            }
            &.wrong-pin {
              border: 1px solid #E70016;
            }

            @media (max-width: 1200px) {
              font-size: 50px;
            }
          }
        }
      }
      .box-submit {
        button {
          width: 185px;
          height: 40px;
          padding: 0px;
          margin: 0px 15px;
          overflow: hidden;
          position: relative;
          background: #00C300;
          border-radius: 20px;
          border: 1px solid #00C300;
          svg {
            position: absolute;
            left: 10px;
            top: 8px;
          }
          &.btn-disabled {
            background: #bfbfbf;
            border: 1px solid #bfbfbf;
          }
          &.btn-cancel {
            background: #E70016;
            border: 1px solid #E70016;
          }
          &.box-reset {
            background: #1A5CAC;
            border: 1px solid #1A5CAC;
          }
        }
      }
    }
    .box-forgot {
      p {
        color: #434343;
        font-weight: 600;
        span {
          color: #E70016;
          cursor: pointer;
          svg {
            font-size: 19px;
          }
        }
      }
    }
  }
  @media (orientation: portrait) {
    #modal-input-pin {
      display: none !important;
    }
  }
</style>
